/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOasVisitor } from '../../visitors/IOasVisitor';
import { Oas20Response } from './Oas20Response';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Oas20Response
 * @author eric.wittmann@gmail.com
 */
export class Oas20ResponseDefinition extends Oas20Response implements IDefinition {
    public constructor(name : string) {
        super(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Parameter#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOasVisitor = <IOasVisitor><any>visitor;
        viz.visitResponseDefinition(this);
    }
}
Oas20ResponseDefinition["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinition";
Oas20ResponseDefinition["__interfaces"] = ["io.apicurio.datamodels.openapi.models.IOasHeaderParent","io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExampleParent","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




